import { call } from '@everlutionsk/helpers';
import { useBrowserLocation } from '@everlutionsk/ui';
import { Navigate } from '@everlutionsk/ui-router';
import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';

type ErrorPageType = '404' | '403' | undefined;

interface ErrorPageContextType {
  errorPage: ErrorPageType;
  setErrorPage: (error: ErrorPageType) => void;
}

const errorPageContext = createContext<ErrorPageContextType | undefined>(undefined);
const { Provider } = errorPageContext;

export function ErrorPageProvider(props: { children: ReactNode }) {
  const [errorPage, setErrorPage] = useState<
    { page: ErrorPageType; locationKey: string | undefined } | undefined
  >(undefined);

  const location = useBrowserLocation();
  useEffect(() => {
    setErrorPage(undefined);
  }, [location.key]);

  const children = call((): ReactNode => {
    if (errorPage?.page === '403') return <Navigate to="/*" />;
    if (errorPage?.page === '404') return <Navigate to="/*" />;

    return props.children;
  });

  return (
    <Provider
      value={{
        errorPage: errorPage?.page,
        setErrorPage: (page: ErrorPageType) => setErrorPage({ page, locationKey: location.key })
      }}
    >
      {children}
    </Provider>
  );
}

export function useErrorPage() {
  const state = useContext(errorPageContext);
  if (state == null) throw Error('Missing error page provider!');

  return { setErrorPage: state.setErrorPage };
}
